import {
    Container,
    Paper,
    Typography,
    Box,
    TextField,
    Button,
    Divider
} from "@mui/material";

import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
export default function EmergencyInformationForm({

    data,

    errors,

    handleChange,

    onBack,

    onContinue

}) {


    const updateContact = (contact, field, value) => {

        handleChange(contact)({

            target: {

                name: field,

                value

            }

        });

    };


    const contacts = [
        "contact1",
        "contact2"
    ];


    return (

            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography
                    variant="h4"
                    gutterBottom
                >

                    Emergency Contact Information

                </Typography>


                <Typography sx={{ mb: 4, color: "rgba(0,0,0,0.6)", }}>

                    Please provide details of two emergency contacts.

                    Your first contact should be the person we should contact
                    in an emergency.

                </Typography>



                {
                    contacts.map((contactKey, index) => {

                        const contact = data[contactKey];


                        return (

                            <Box key={contactKey}>


                                <Typography
                                    variant="h6"
                                    sx={{ mb: 2 }}
                                >

                                    Contact {index + 1}

                                </Typography>



                                <Box

                                    sx={{

                                        display: "grid",

                                        gap: 2,

                                        gridTemplateColumns: {

                                            xs: "1fr",

                                            md: "1fr 1fr"

                                        }

                                    }}

                                >


                                    <TextField

                                        label="Name"

                                        name="name"

                                        value={
                                            contact.name
                                        }

                                        onChange={(e) =>
                                            updateContact(
                                                contactKey,
                                                "name",
                                                e.target.value
                                            )
                                        }

                                        error={
                                            !!errors[
                                                `contact_${index}_name`
                                            ]
                                        }

                                        helperText={
                                            errors[
                                                `contact_${index}_name`
                                            ]
                                        }

                                    />



                                    <TextField

                                        label="Relationship"

                                        name="relationship"

                                        value={
                                            contact.relationship
                                        }

                                        onChange={(e) =>
                                            updateContact(
                                                contactKey,
                                                "relationship",
                                                e.target.value
                                            )
                                        }

                                        error={
                                            !!errors[
                                                `contact_${index}_relationship`
                                            ]
                                        }

                                        helperText={
                                            errors[
                                                `contact_${index}_relationship`
                                            ]
                                        }

                                    />



                                    <TextField

                                        label="Telephone Number"

                                        name="telephoneNumber"

                                        value={
                                            contact.telephoneNumber
                                        }

                                        onChange={(e) =>
                                            updateContact(
                                                contactKey,
                                                "telephoneNumber",
                                                e.target.value
                                            )
                                        }

                                        error={
                                            !!errors[
                                                `contact_${index}_telephoneNumber`
                                            ]
                                        }

                                        helperText={
                                            errors[
                                                `contact_${index}_telephoneNumber`
                                            ]
                                        }

                                    />


                                </Box>



                                {
                                    index === 0 && (

                                        <Divider

                                            sx={{
                                                my: 4
                                            }}

                                        />

                                    )

                                }


                            </Box>

                        );

                    })

                }




                <Box

                    sx={{

                        display: "flex",

                        justifyContent: "space-between",

                        mt: 5

                    }}

                >


                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>
                    <Button
                       className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>


                </Box>



            </Paper>

    );

}